import React, { useState, useEffect } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import firebase from '../firebase/firebase';
import { Redirect, Route } from 'react-router-dom';

const checkIfUserIsSignedIn = async () => {
    const isPasswordlessSignIn = firebase.auth().isSignInWithEmailLink(window.location.href)
    if (!isPasswordlessSignIn) return false;
    let email = window.localStorage.getItem('emailForSignIn');

    try {
        let res = await firebase.auth().signInWithEmailLink(email, window.location.href)
        if (res) {
            window.localStorage.removeItem('emailForSignIn')
            return true
        }

        return false;
    } catch (e) {
        // window.alert('Something went wrong, going back to login page')
        return false;
    }
}

export const PrivateRoute = ({ Component, ...rest }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const result = await checkIfUserIsSignedIn();

            setIsAuthenticated(result);
            setLoading(false);
        };

        firebase.auth().onAuthStateChanged(user => {
            if (user != null) {
                setIsAuthenticated(true)
            } else {
                fetchData();
            }
        });
    }, []);

    return (
        <Route
            {...rest}
            render={() =>
                isAuthenticated ? (
                    <Component {...rest} />
                ) : loading ? (
                    <CircularProgress />
                ) : (
                            <Redirect
                                to={{
                                    pathname: "/",
                                }}
                            />
                        )
            }
        />
    );
};
